export const enum StatsPlatformEnum {
  all = '',
  gtm = 'GTM',
  sp1 = 'SP1',
  sp2 = 'SP2',
}
